import { render, staticRenderFns } from "./SubjectGroups.vue?vue&type=template&id=3d2fcfcd&scoped=true"
import script from "./SubjectGroups.vue?vue&type=script&lang=js"
export * from "./SubjectGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2fcfcd",
  null
  
)

export default component.exports